import { render, staticRenderFns } from "./VuetableSwitch.vue?vue&type=template&id=44b1767e"
import script from "./VuetableSwitch.vue?vue&type=script&lang=js"
export * from "./VuetableSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports